import { RouteObject } from 'react-router-dom';
import { Inbox } from '../Inbox';
import { TicketFlowProvider } from '../context';

export const InboxRoutes: RouteObject[] = [
  {
    path: 'inbox',
    element: (
      <TicketFlowProvider>
        <Inbox />
      </TicketFlowProvider>
    ),
  },
];
